export enum Gender {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
    OTHER = 'OTHER'
}

// Remove IdType enum since we're using IdTypeApiEnum

export enum VehicleType {
    CAR = 'CAR',
    MOTORCYCLE = 'MOTORCYCLE',
    BICYCLE = 'BICYCLE',
    OTHER = 'OTHER'
}

export enum PetType {
    DOG = 'DOG',
    CAT = 'CAT',
    OTHER = 'OTHER'
}

export enum FileType {
    ID_FRONT = 'ID_FRONT',
    ID_BACK = 'ID_BACK',
    SELFIE = 'SELFIE',
    OTHER = 'OTHER'
}

export enum ValidationErrorType {
    REQUIRED = 'required',
    FORMAT = 'format',
    INVALID = 'invalid'
}

export enum FormSeverity {
    INFO = 'info',
    WARNING = 'warning',
    SUCCESS = 'success',
    ERROR = 'error'
}

export enum StatusColor {
    BLUE = 'blue',
    YELLOW = 'yellow',
    GREEN = 'green',
    RED = 'red',
    ORANGE = 'orange'
}

export enum MimeType {
    JPEG = 'image/jpeg',
    PNG = 'image/png'
}
